import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import * as XLSX from 'xlsx';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';
type AOA = any[][];


@Component({
  selector: 'app-create-doa-filter',
  templateUrl: './create-doa-filter.component.html',
  styleUrls: ['./create-doa-filter.component.css']
})
export class CreateDoaFilterComponent implements OnInit, AfterViewInit {
  isBright: boolean = true;
  isOpenDoctypeModel: boolean = true;
  selectedDocumentType: any = { docTypeId: 0, docTypeName: '', isCommentMandatory: false };
  RoleList: { RoleId: number, RoleName: string }[] = [];


  docTypeList: any = [];
  documentType_MST: any;

  workItemFieldList: any = [];


  modalReference: any;

  ApproverList: { ApproverId: number, ApproverName: string }[] = [];
  field_ids: string = "0";
  lstSection = [];
  db_columns_values_list = {};
  frmInvoice: FormGroup;

  fileControlType = 'file';
  base64FileString: string = '';
  invoiceDocValidFileExtensions = [];
  @ViewChild('invFileUpload') fileInput: ElementRef;
  @ViewChild('DOAFileUpload') DOAfile: ElementRef;
  invoiceDocFileSize = {};

  //basic fields:
  Approvernm: any = "";
  Levelval: any = "";
  Managernm: any = "";

  //Submit param
  submitted: boolean = false;
  invoiceComment = 'invoiceComment';
  isDuplicate: boolean = false;
  lstDuplicateData: any = [];
  duplicateDataKeys: any = [];
  @ViewChild('duplicateInvoiceSubmittedModal') duplicateInvoiceSubmittedModal: ElementRef;
  potentialDuplicate: string = '';
  finalValue: string = 'Normal';
  selectedSubDocumentType: any = { subdocTypeId: 0, subdocTypeName: '' };
  attachmentList = [];
  createdInvoiceURN: string = '';
  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;




  edit_flag: number = 0;


  //Bulk Upload Params
  browseMessage = "No file selected.";
  selectedExcelFile = this.browseMessage;
  fileTitle = "Choose file";

  excelDataTemplate: any;
  folderName: string;
  excelFileData: any = [];
  data: AOA;
  import_excel_file_data: any;
  db_col_name_array: any = [];
  field_name_array: any = [];



  jsonData: string;

  //Usercreation
  loginidval: string = "";
  Usernameval: string = "";
  Emailval: string = "";
  rolselval: string

  @ViewChild('approvermenu') approvermenu: MatSelect;
  ApproverData: any;
  addclick: boolean = false;
  currentpopup: string;

  Useraddbtn = "Add User"
  DOA_Datafieldlist: any[];
  uploadedfilePath: any;
  excelData: any;
  errordata: any[];
  fieldobj: {};
  msg: string;


  @Input() data_field = [];
  @Output() cellClickEvent = new EventEmitter<any>();

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) { }

  ngOnInit(): void {
    this.getWorkItemFields();

  }


  ngAfterViewInit() {

  }



  onGridCellClick(event: any) {



  }

  getWorkItemFields() {
    this.workItemFieldList = this.data_field;
    this.DOA_Datafieldlist = [];
    this.db_col_name_array = [];
    this.field_name_array = [];

    this.fieldobj = {};
    this.lstSection = [];
    this.workItemFieldList.forEach(item => {

      if (this.lstSection.findIndex(s => s.SECTION_NAME == item.section_name) == -1) {
        let lst = this.workItemFieldList.filter(x => x.section_name == item.section_name);
        this.lstSection.push({ SECTION_ID: item.section_name, SECTION_NAME: item.section_name, FIELDS_DETAIL: lst, SECTION_ORDER: item.section_order });
      }
    });
    const formControls: any = {};
    this.workItemFieldList.forEach(async (field) => {

      field.is_mandatory = 1
      //  field.is_readonly = 0;
      this.db_col_name_array.push(field.db_column_name);
      this.field_name_array.push(field.field_name);


      let fieldValidators = [];
      // if (
      //   field.control_type == 'FILE' ||
      //   field.is_mandatory == 1
      // ) {
      //   fieldValidators = [Validators.required];
      // }

      let defaultValue =
        field.control_type == 'DATE' ? null :
          field.control_type == 'DROPDOWN' ? field.dropdown_type == 'PredefinedMst' && field.dropdown_value != null ? +field.dropdown_value.trim() : null :
            field.control_type == 'CHECKBOX' ? false : '';

      this.db_columns_values_list[field.db_column_name] = defaultValue;

      formControls[field.db_column_name] =
        new FormControl({
          value: defaultValue,
          disabled: field.is_readonly == 1
        }, fieldValidators);

      if (field.control_type == 'TEXTBOX') {
        field.value_type = field.validation_type == 'NUMERIC' ? 'number' : 'text';
      }
      if (field.actions != null) {
        debugger
        field.actions = JSON.parse(field.actions);
      }
      if (field.control_type == 'DROPDOWN') {

        //By Prakash
        //field.options = JSON.parse(field.options);
        let magnify_dependant_fields = {};
        let dropdown_dependant_parameter = {};
        if (field.magnify_dependant_fields != null && field.magnify_dependant_fields != undefined) {
          magnify_dependant_fields = JSON.parse(field.magnify_dependant_fields);
          Object.keys(magnify_dependant_fields).forEach(x => {

            let field_value = this.db_columns_values_list[magnify_dependant_fields[x]];
            if (field_value != null && field_value != '' && field_value != undefined) {
              dropdown_dependant_parameter[x] = field_value.toString();
            }
          });
        }
        field.dropdown_dependant_parameter = dropdown_dependant_parameter;

        if (field.is_autocomplete == 0 && field.is_readonly == 0) {
          field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
          //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
        }
        else if (field.is_autocomplete == 0 && field.is_readonly == 1) {
          if (defaultValue != null && defaultValue != undefined)
            field.field_value = defaultValue;
          if (field.field_value == "" || field.field_value == undefined)
            field.field_value = 0;

          field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
        }
        else {
          if (field.field_value == "" || field.field_value == undefined)
            field.field_value = "";

          field.options = await this.commonService.getAutocomplete_dropdowndata(field.field_mapping_detail_id, field.field_value, 'id')
          //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
        }
        //Gabriel start
        //dependant field event called for page load if fields readonly
        if (field.is_dependant == 1 && field.field_value != null) {
          // this.getDependantFields(field.field_mapping_detail_id, fieldVal);                    
          this.getDependantFields(
            field.field_mapping_detail_id, field.field_value
          );
          //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
          //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
        }
        //Gabriel end

        //field.options = [...new Map(field.options.map(item => [item['name'], item])).values()];
        // field.options.splice(0, 0, { id: 0, name: '-- Select --' });
      }
      this.DOA_Datafieldlist.push(field)
      this.DOA_Datafieldlist = this.DOA_Datafieldlist.sort((a, b) => {
        if (a.field_order < b.field_order) {
          return -1;
        }
        return a;
      });
    });



    this.frmInvoice = new FormGroup(formControls);




  }

  onResetButtonClick() {
    this.edit_flag = 0;


    this.Approvernm = 0;
    this.Levelval = 0;
    this.Managernm = 0;

    this.frmInvoice.reset();
    this.frmInvoice.markAsPristine();
    this.frmInvoice.markAsUntouched();




  }
  get f() {
    return this.frmInvoice.controls;
  }



  changeTextFieldValue(field: any) {
    let field_value = this.frmInvoice.get(field.db_column_name).value;

    if (field.is_dependant == 1) {
      this.getDependantFields(
        field.field_mapping_detail_id,
        field_value
      );
    }

    if (field.actions != null) {
      // execute actions/query if any
      field.actions.forEach(action => {
        if (action.action_type == 'SET_VALUE' && action.execute_mode == 'FORMULA' && action.action_trigger == 'VALUE_CHANGE') {
          let formula = action.formula;

          action.formula_fields.split(",").forEach(f => {
            let field_value = this.frmInvoice.get(f).value;
            formula = formula.replace(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
          });
          let formulaValue = eval(formula);

          this.frmInvoice.get(action.target_db_column_name)
            .setValue(formulaValue);
        }
      });
    }

    if (field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') {
      field_value = this.commonService.handleNumberInput(field, field_value);
      this.frmInvoice.get(field.db_column_name).setValue(field_value);
    }

  }

  getDependantFields(fieldMappingDetailId: number, selectedValue: any) {
    let params = {
      field_mapping_detail_id: fieldMappingDetailId,
      selected_value: selectedValue,
      xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };

    this.dataService.getData('dependant', params).subscribe((res) => {
      if (res != null && res != undefined) {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data.length > 0) {
            res.data.forEach((ele) => {
              ele.values = JSON.parse(ele.values);
              if (ele.control_type == 'DROPDOWN') {
                const uniqueData = [...new Map(ele.values.map(item => [item['name'], item])).values()];
                this.workItemFieldList.find(
                  (x) => x.db_column_name == ele.db_column_name
                ).options = uniqueData;
                if (uniqueData.length == 1) {
                  this.frmInvoice
                    .get(ele.db_column_name)
                    .setValue(uniqueData[0]['id']);
                }
              } else if (ele.control_type == 'TEXTBOX') {
                if (ele.values.length > 0) {
                  this.frmInvoice
                    .get(ele.db_column_name)
                    .setValue(ele.values[0].name);
                } else {
                  this.frmInvoice.get(ele.db_column_name).setValue('');
                }
              }
            });
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }

      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }





  callOnAutoCompleteChangedEvent(data) {
    this.frmInvoice.get(data.db_column_name).setValue(data.fieldValue);
    if (data.control_type == 'DROPDOWN') {
      this.changeDropdownFieldValue(data);
    } else if (data.control_type == 'TEXTBOX') {
      this.changeTextFieldValue(data);
    }
  }

  changeDropdownFieldValue(field: any) {
    if (field.is_dependant == 1) {
      this.getDependantFields(
        field.field_mapping_detail_id,
        this.frmInvoice.get(field.db_column_name).value
      );
    }
  }


  openAdvanceSearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null, predefinedTableColumnName: string = 'id') {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field_value = this.frmInvoice.get(magnifyDependantFields[x]).value;
        if (field_value != null && field_value != '' && field_value != undefined) {
          // let field = this.workItemFieldList.find(f => f.db_column_name == magnifyDependantFields[x]);
          // if (field != undefined && field.control_type == 'DROPDOWN') {
          //   field_value = field.options.find(d => d.id == field_value).name;
          // }
          dependantFieldValues[x] = field_value.toString();
        }
      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.predefinedTableColumnName = predefinedTableColumnName;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {

      const selectedField = this.workItemFieldList.find(
        (x) => x.field_mapping_detail_id == res.fieldId
      );

      if (selectedField.control_type == 'DROPDOWN') {
        const selectedOptionField = selectedField.options.find(
          (x) => x.id == res.fieldValue
        );
        this.frmInvoice
          .get(selectedField.db_column_name)
          .setValue(selectedOptionField['id']);
        this.changeDropdownFieldValue(selectedField);
      } else if (selectedField.control_type == 'TEXTBOX') {
        this.frmInvoice
          .get(selectedField.db_column_name)
          .setValue(res.fieldValue.toString());
        this.changeTextFieldValue(selectedField);
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }


  omit_special_char(e, regExp) {
    // var k;
    // k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));

    //var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    if (regExp == "" || regExp == null || regExp == undefined)
      return true;

    var regex = new RegExp(regExp);
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }

  omit_onPaste(e) {
    ///(paste)="onPaste($event)" add this line into html input.
    e.preventDefault();
    return false;
  }

  onTextBoxKeyPressEvent(event: any, field: any) {
    const reg = this.commonService.getRegForDecimal;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  showModal(modelTemplate, modalSize: string = 'lg', popup: string) {

    if (popup == "Approver" || popup == "Manager") {
      $("#userbtn").addClass("smallButton")
      $("#userbtn").removeClass("resetButton")
      this.Useraddbtn = "Add User"
      this.addclick = false
    }


    if (popup == "Approver") {
      this.currentpopup = "Approver"
    }
    else if (popup == "Manager") {
      this.currentpopup = "Manager"
    }
    else {
      this.currentpopup = ""
    }

    this.approvermenu.close();
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });

    this.approvermenu.close();
  }

  addclicked(e) {
    if ($("#userbtn").hasClass("smallButton")) {
      $("#userbtn").addClass("resetButton")
      $("#userbtn").removeClass("smallButton")
    }
    else {
      $("#userbtn").addClass("smallButton")
      $("#userbtn").removeClass("resetButton")
    }

    if (this.addclick == true) {
      this.Useraddbtn = "Add User"

    }
    else {
      this.Useraddbtn = "Go Back"
    }

    this.addclick = !this.addclick


  }







  downloadDOAUploadfile(file_id) {
    this.excelData = [];
    let params = {
      project_id: this.commonService.selectedProject,
      doc_id: this.selectedDocumentType.docTypeId,
      file_id: file_id,
      field_ids: this.field_ids
    };
    this.dataService.getData('getDOAUploadfile', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        this.excelData = res.data.Table
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelData);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'DOAData');
        XLSX.writeFile(wb, 'DOAData.xlsx');
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })
  }



  submitInvoice() {

    this.submitted = true;
    let isSubmitValid = true;
    let invalidSubmitMsg = '';
    let invalidLengthMsg = '';



    let fieldsData = [];
    let lst = [];
    let lstRow = this.frmInvoice.getRawValue();
    let formValue = "";

    this.workItemFieldList.forEach(field => {

      formValue = lstRow[field.db_column_name];
      let displayText = '';

      if (formValue != undefined && formValue != null)
        formValue = formValue.toString();
      else
        formValue = '';


      let value: string = formValue

      if (field.control_type == "DROPDOWN") {
        displayText = field.options.find(d => d.id == value) ?.name;
      }

      fieldsData.push({
        db_column_name: field.db_column_name,
        field_val: value.toString().trim(),
        controlType: field.control_type,
        displayText: displayText == undefined ? '' : displayText
      });



    });
    this.cellClickEvent.emit(fieldsData)


  }




}
